export default __webpack_public_path__ + "static/media/moreIcon.f4169ba0.svg";